import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { MonthYear } from '@app/domain/model/monthYear';

@Injectable({
  providedIn: 'root'
})
export class GenerateIndustryReportService {

  requestParams: HttpParams;

  queryReportType: string;

  constructor(private readonly http: HttpClient) { }


  generateIndustryReport(month: MonthYear) {

    return this.http.get(
      'dealers/reports/industry/generate/',
      {
        params:  new HttpParams().set('month', this.formatDate(month)),
        responseType: 'text'
      }
    );
  }

  private formatDate(date: MonthYear) {
    const month: number = date.month,
           year: number = date.year;
    return year.toString() + '-' + (month > 9 ? month.toString() : '0' + month.toString());
  }
}
